import { push } from '@lagunovsky/redux-react-router';
import * as R from 'ramda';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import { withLogin } from '../../../reactutils/withLogin';
import { myProfileBettingPath } from '../../../screens/UserProfileScreen';
import { HighscoreInfo } from '../../../services/betting';
import { groupInternalHighscorePath } from '../../GroupInternalHighscores';
import { userIdSelector, userNameSelector } from '../../System/selectors';
import { userGroupChatPath } from '../../TeamChat';
import { tournamentSelectionTournamentIdSelector } from '../../TournamentSelectionComponent/selectors';
import { bettingProfileLoadHighscoreInfos } from '../BettingProfile/actions';
import { bettingProfileMyHighscoresSelector } from '../BettingProfile/selectors';
import { myGroupHighscoresForward, myGroupHighscoresGotoHighscore, myGroupHighscoresLoad, myGroupHighscoresRefreshUnreadTeamChatMessages } from './actions';
import {
    myGroupHighscoreRankSelector,
    myGroupHighscoreTotalGroupsSelector,
    myGroupHighscoreUgIdSelector,
    myGroupHighscoreUgNameSelector,
    myGroupHighscoreUnreadChatCountSelector
} from './selector';

export const MyHighscore: FC<{}> = () => {
    const selectedTournamentId = useSelector(tournamentSelectionTournamentIdSelector);
    const myHighscore = useSelector(bettingProfileMyHighscoresSelector);
    const userName = useSelector(userNameSelector);
    const userId = useSelector(userIdSelector);

    const dispatch = useDispatch();

    const [highscore, setHighscore] = useState<HighscoreInfo>();

    useEffect(() => {
        if (userId) {
            dispatch(bettingProfileLoadHighscoreInfos());
        }
    }, [dispatch, userId]);

    useEffect(() => {
        if (userId) {
            const hs = myHighscore.find(hs => hs.tournamentId === String(selectedTournamentId));
            setHighscore(hs);
        }
    }, [selectedTournamentId, myHighscore, userId]);

    const onClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (userId && selectedTournamentId) {
            dispatch(myGroupHighscoresGotoHighscore(String(selectedTournamentId)));
        }
    };

    if (!userId) {
        return null;
    } else if (highscore) {
        return (
            <>
                <div className="text-white font-weight-bold" style={{ fontSize: '0.8rem', lineHeight: '1rem' }}>
                    {userName}
                </div>
                <Link
                    to="/#"
                    className="text-success font-weight-light button"
                    style={{ fontSize: '0.8rem', lineHeight: '1rem' }}
                    onClick={onClick}
                >
                    Platz {highscore.rank} / {highscore.count}
                </Link>
            </>
        );
    } else {
        return (
            <>
                <div className="text-white font-weight-bold" style={{ fontSize: '0.8rem', lineHeight: '1rem' }}>
                    {userName}
                </div>
                <Link
                    to="/#"
                    className="text-success font-weight-light button"
                    style={{ fontSize: '0.8rem', lineHeight: '1rem' }}
                    onClick={onClick}
                >
                    Noch keine Wertung
                </Link>
            </>
        );
    }
};

const MyGroupHighscoreForwarderComponent: FC<{}> = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(push(groupInternalHighscorePath('1', '')));
    }, [dispatch]);

    return null;
};

export const myGroupHighscorePath = () => `/b/my-group-highscores`;

export const MyGroupHighscoreForwarder = R.compose(withLogin())(MyGroupHighscoreForwarderComponent);

export const MyGroupHighscores: FC<{}> = () => {
    const selectedTournamentId = useSelector(tournamentSelectionTournamentIdSelector);
    // const trId = useSelector(tournamentSelectionSelectedTournamentRoundIdSelector('highscores'));
    const userId = useSelector(userIdSelector);

    const rank = useSelector(myGroupHighscoreRankSelector);
    const totalGroupCount = useSelector(myGroupHighscoreTotalGroupsSelector);
    const ugId = useSelector(myGroupHighscoreUgIdSelector);
    const ugName = useSelector(myGroupHighscoreUgNameSelector);
    const unreadChatCount = useSelector(myGroupHighscoreUnreadChatCountSelector);

    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedTournamentId && userId) {
            dispatch(myGroupHighscoresLoad(String(selectedTournamentId)));
        }
    }, [selectedTournamentId, userId, dispatch]);

    useEffect(() => {
        const interval = setInterval(() => dispatch(myGroupHighscoresRefreshUnreadTeamChatMessages(ugId)), 120000);
        return () => clearInterval(interval);
    }, [dispatch, ugId]);

    const onClick = (e: React.MouseEvent) => {
        e.preventDefault();
        dispatch(myGroupHighscoresForward(ugId));
    };

    if (!userId) {
        return null;
    }
    if (ugId) {
        if (rank && totalGroupCount) {
            return (
                <>
                    <div className="text-white font-weight-bold" style={{ fontSize: '0.8rem', lineHeight: '1rem' }}>
                        Tippteam {ugName}
                        {unreadChatCount > 0 && (
                            <Link to={userGroupChatPath(ugId)}>
                                <Badge className="ms-1" color="danger">
                                    {unreadChatCount}
                                </Badge>
                            </Link>
                        )}
                    </div>
                    <Link
                        to="/#"
                        className="text-success font-weight-light button"
                        style={{ fontSize: '0.8rem', lineHeight: '1rem' }}
                        onClick={onClick}
                    >
                        Platz {rank} / {totalGroupCount}
                    </Link>
                </>
            );
        } else {
            return <span>lade ...</span>;
        }
    } else {
        return (
            <>
                <div className="text-white font-weight-bold" style={{ fontSize: '0.8rem', lineHeight: '1rem' }}>
                    Tippteam {ugName}
                </div>
                <Link
                    to={myProfileBettingPath()}
                    className="text-success font-weight-light button"
                    style={{ fontSize: '0.8rem', lineHeight: '1rem' }}
                >
                    Jetzt Team anlegen
                </Link>
            </>
        );
    }
};
